<template>
  <div>
    <van-action-sheet v-model="show" :title="$t('uniform.select_specifications')" style="height: 80%" @close="showAction">
      <div v-if="itemList.img">
        <div class="content" v-if="!itemList.is_bundles">
          <div class="flex">
            <img :src="imgUrl" alt="" class="img72" />
            <div class="flex1 ml-10">
              <div class="color3 mt-5 font16 fontWeight">{{ itemList.title }}</div>
              <div class="flex1 font18 mt-15">
                <span class="colorRed fontWeight"><span class="font12">¥ </span>{{ currentPrice }}</span
                ><span class="van-card__origin-price" v-if="scribing_price != ''">¥ {{ scribing_price }}</span>
              </div>
            </div>
          </div>
          <div class="categoryTitle">{{ $t("uniform.Color") }}</div>
          <van-row gutter="20">
            <span v-for="(list, key, index) in colorItem" :key="index">
              <span class="tagList" :class="key == colorNum ? 'currentTag' : ''" @click="colorClick(key)" v-if="!list.disabled">{{ list.title }}</span>
              <span class="tagList disabledTag" v-else>{{ list.title }}</span>
            </span>
          </van-row>
          <div class="categoryTitle">{{ $t("uniform.Size") }}</div>
          <van-row gutter="20">
            <span v-for="(list, key, index) in sizeItem" :key="index"
              ><span class="tagList" :class="key == sizeNum ? 'currentTag' : ''" @click="sizeClick(key)" v-if="!list.disabled"
            >{{ list.title }} <span class="NoStock" v-if="currentStock <= 0 && key == sizeNum && itemList.presale == 0 && itemList.unlimited == 0 && colorNum != ''">{{ $t("uniform.Out_stock") }}</span> <span class="presale" v-if="colorNum != '' && currentStock <= 0 && key == sizeNum && itemList.presale == 1">{{ $t("uniform.Presale") }}</span>
              </span>
              <span class="tagList disabledTag" v-else>{{ list.title }}</span>
            </span>
          </van-row>
          <div class="van-sku-stepper-stock categoryTitle">
            <div class="van-sku__stepper-title font14"> 
              {{ $t("uniform.Quantity") }} <span class="font12 color9 ml-10" v-if="sizeNum != '' && colorNum != '' && itemList.presale != 1 && itemList.unlimited != 1"  >{{ $t("uniform.Stock_Quantity") }}{{ currentStock >= 0 ? currentStock: 0}}</span>
            </div>
            <div class="van-stepper van-sku__stepper" v-if="currentStock != 0 || itemList.unlimited == 1">
              <button type="button" class="van-stepper__minus" @click="reduceNum" :class="quantityNum == 1  ? 'van-stepper__minus--disabled' : ''"></button>
              <input type="tel" v-model="quantityNum" class="van-stepper__input" />
              <button type="button" class="van-stepper__plus" @click="addNum" :class="itemList.unlimited == 1 ? '' : quantityNum >= currentStock ? 'van-stepper__minus--disabled' : ''"></button>
            </div>
            <div class="van-stepper van-sku__stepper" v-if="currentStock == 0 && itemList.unlimited != 1">
              <button type="button" class="van-stepper__minus van-stepper__minus--disabled"></button>
              <input type="tel" v-model="quantityNum" class="van-stepper__input" />
              <button type="button" class="van-stepper__plus van-stepper__minus--disabled"></button>
            </div>
          </div>
          <van-notice-bar class="noticeBto" v-if="currentStock <= 0 && itemList.presale == 1 && sizeNum != '' && colorNum != ''" color="#666666" background="#F2F3F5" left-icon="info-o" :text="$t('uniform.Presale_Description')" />
          <van-goods-action v-if="currentStock !== null && currentStock <= 0 && itemList.unlimited == 0" class="p10">
            <van-goods-action-button color="#4D88D2" type="warning" :text="$t('uniform.Out_stock')" :loading="registerLoading" disabled />
          </van-goods-action>
          <van-goods-action v-else class="p10">
            <van-goods-action-button color="#4D88D2" type="warning" @click="addShop" :text="$t('uniform.Add_To_Cart')" />
            <van-goods-action-button color="#F5A429" type="danger" :text="$t('uniform.buy_Now')" @click="buyNow" :loading="showLoading" :disabled="showLoading" />
          </van-goods-action>
        </div>
        <div class="content" v-if="itemList.is_bundles">
          <div>
            <div class="color3 font16 fontWeight">{{ itemList.title }}</div>
            <div class="flex1 font18 mt-5">
              <span class="colorRed fontWeight"><span class="font12">¥ </span> {{ currentPrice }}</span
              ><span class="van-card__origin-price" v-if="scribing_price != ''">¥ {{ scribing_price }}</span
              ><span class="font12 color6 ml-10"> {{ $t("uniform.bundle_items_count", { x: getBundleNum(itemList.bundle_items) }) }}</span>
            </div>
          </div>
          <div class="categoryTitle">{{$t("uniform.Set_Sizes")}}</div>
          <van-row gutter="20">
            <span v-for="(list, key, index) in sizeItem" :key="index"
              ><span class="tagList" :class="key == sizeNum ? 'currentTag' : ''" @click="sizeClick(key)" v-if="!list.disabled">{{ list.title }} <span class="presale" v-if="colorNum != '' && currentStock <= 0 && key == sizeNum && itemList.presale == 1">{{ $t("uniform.Presale") }}</span></span>
              <span class="tagList disabledTag" v-else>{{ list.title }}</span>
            </span>
          </van-row>
          <div v-for="(lists, index) in itemList.bundle_items" :key="index">
            <div class="flex alignStart mt-20 mb-5" v-if='itemList.bundleInfo[lists.pid]'>
              <img v-if="itemList.bundleInfo[lists.pid].img[itemList.bundleInfo[lists.pid].attr.color.item[lists.attr1]]" :src="itemList.bundleInfo[lists.pid].img[itemList.bundleInfo[lists.pid].attr.color.item[lists.attr1]][0]" alt="" class="img72" />
              <img v-else :src="itemList.bundleInfo[lists.pid].img.all[0]" alt="" class="img72" />
              <div class="flex1 align-items ml-10">
                <div class="flex align-items mt-5">
                  <div class="flex1 font14 color3 fontWeight">{{ lists.abb_title }}</div>
                  <span class="color3 font14 fontWeight">¥ {{ itemList.bundleInfo[lists.pid].unit_price }}</span>
                </div>
                <div class="mt-15">
                  <span  class="font12 color6">{{ itemList.bundleInfo[lists.pid].attr.color.item[lists.attr1] }}<span v-if='itemList.bundleInfo[lists.pid].attr_special.length==0 && lists.sizeNum != ""'> / {{ sizeItem[lists.sizeNum].title }}</span>
                      <span v-else-if="itemList.bundleInfo[lists.pid].attr_special.list">{{ itemList.bundleInfo[lists.pid].attr.size.item[itemList.bundleInfo[lists.pid].attr_special.list[lists.sizeNum]] }}</span> 
                      <span v-else-if="itemList.bundleInfo[lists.pid].attr_special.only">{{ itemList.bundleInfo[lists.pid].attr.size.item[itemList.bundleInfo[lists.pid].attr_special.only] }}</span>
                    </span>
                  <!-- <span class="font12 suitLabel"
                    ><span class="color6"></span><span class="color3">{{ itemList.bundleInfo[lists.pid].attr.color.item[lists.attr1] }}</span></span
                  >
                  <span class="font12 suitLabel ml-10" v-if="lists.sizeNum != ''" @click="lists.showSize = !lists.showSize"
                    ><span class="color6">尺码：</span><span class="color3">{{ sizeItem[lists.sizeNum].title }}</span> <van-icon name="arrow-up" v-if="lists.showSize" class="color6 ml-5" /><van-icon name="arrow-down" v-if="!lists.showSize" class="color6 ml-5" />
                  </span>
                  <span class="font12 colorWarning ml-5" v-if="lists.sizeNum != '' && lists.sizeNum != sizeNum"><van-icon name="warning-o" /> 注意核对</span>
                  <span class="fr color6 font12 mt-4">x{{ lists.num }}</span> -->
                </div>
              </div>
            </div>
            <van-row gutter="20" v-if="lists.showSize">
              <span v-for="(list, key, index) in sizeItem" :key="index"
                ><span class="tagList" :class="key == lists.sizeNum ? 'currentTag' : ''" @click="suitSizeClick(lists, key)" v-if="!list.disabled"
                  >{{ list.title }} <span class="NoStock" v-if="currentStock <= 0 && key == sizeNum">{{ $t("uniform.Out_stock") }}</span>
                </span>
                <span class="tagList disabledTag" v-else>{{ list.title }}</span>
              </span>
            </van-row>
          </div>
          <div class="van-sku-stepper-stock categoryTitle">
            <div class="van-sku__stepper-title font14">
              {{ $t("uniform.Quantity") }} <span class="font12 color9 ml-10" v-if="sizeNum != '' && colorNum != '' && itemList.presale != 1  && itemList.unlimited != 1">{{ $t("uniform.Stock_Quantity") }}{{ currentStock >= 0 ? currentStock : 0 }}</span>
            </div>
            <div class="van-stepper van-sku__stepper" v-if="currentStock != 0 || itemList.unlimited == 1"><button type="button" class="van-stepper__minus" @click="reduceNum" :class="quantityNum == 1 ? 'van-stepper__minus--disabled' : ''"></button><input type="tel" v-model="quantityNum" class="van-stepper__input" /><button type="button" class="van-stepper__plus" @click="addNum" :class="itemList.unlimited == 1 ? '' : quantityNum >= currentStock ? 'van-stepper__minus--disabled' : ''"></button></div>
            <div class="van-stepper van-sku__stepper" v-if="currentStock == 0 && itemList.unlimited != 1"><button type="button" class="van-stepper__minus van-stepper__minus--disabled"></button><input type="tel" v-model="quantityNum" class="van-stepper__input" /><button type="button" class="van-stepper__plus van-stepper__minus--disabled"></button></div>
          </div>
          <van-notice-bar class="noticeBto" v-if="currentStock <= 0 && itemList.presale == 1 && sizeNum != '' && colorNum != ''" color="#666666" background="#F2F3F5" left-icon="info-o" :text="$t('uniform.Presale_Description')" />
          <van-goods-action v-if="currentStock !== null && currentStock <= 0 && itemList.unlimited == 0" class="p10">
            <van-goods-action-button color="#4D88D2" type="warning" :text="$t('uniform.Out_stock')" :loading="registerLoading" disabled />
          </van-goods-action>
          <van-goods-action v-else class="p10">
            <van-goods-action-button color="#4D88D2" type="warning" @click="addShop" :text="$t('uniform.Add_To_Cart')" />
            <van-goods-action-button color="#F5A429" type="danger" :text="$t('uniform.buy_Now')" @click="buyNow" :loading="showLoading" :disabled="showLoading" />
          </van-goods-action>
        </div>
      </div>
    </van-action-sheet>
    <div class="short-box" ref="shortList" @click="router">
      <div class="short-btn customer-service shopping" @click="showMask = !showMask" ref="customerService" @touchstart="!showMask && touchstartHandle('customerService', $event)" @touchmove="!showMask && touchmoveHandle('customerService', $event)" @touchend="!showMask && end('customerService')">
        <van-icon name="shopping-cart" color="#fff" size="24" />
        <span class="num" v-if="shopNum != 0">{{ shopNum }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Col, Row, Image as VanImage, ActionSheet, Toast } from "vant";
import { UNIFORM_SHOPPING, CURRENT_CHILD } from "@/store/mutation-types";
import { recordWant, cancelPay } from "@/api/uniform";
import i18n from "../i18n";
// import wx from "weixin-js-sdk";
import storage from "store";
// import { CURRENT_CHILD, UNIFORM_SHOPPING } from "@/store/mutation-types";
Vue.use(Col);
Vue.use(Row);
Vue.use(VanImage);
Vue.use(ActionSheet);
Vue.use(Toast);

const DEFAULT_IMG_URL = "https://m2.files.ivykids.cn/cloud01-file-8025768Frlg5G8ESlkiwyVrQ50DbxZebVHT.png";

export default {
  name: "Children",
  props: {
    actionShow: Boolean,
    shoppingData: Object,
  },
  data() {
    return {
      show: false,
      quantityNum: 1,
      itemList: {},
      colorNum: "",
      sizeNum: "",
      currentStock: null,
      infoList: {},
      colorItem: {},
      sizeItem: {},
      imgUrl: "",
      shopNum: 0,
      child_id: "",
      showLoading: false,
      touch: {
        initialPosition: {
          x: 0,
          y: 500,
        },
        movePostion: {},
      },
      element: {
        initialPosition: {},
        movePostion: {},
      },
      nowLeft: -1,
      classFlag: false,
      showMask: false,
      currentPrice: 0,
      scribing_price: "",
      childData: {},
      registerLoading: false,
    };
  },
  watch: {
    actionShow(val) {
      if (val) {
        this.initAction();
      }
    },
  },
  created() {
    this.show = this.actionShow;
    this.childData = storage.get(CURRENT_CHILD + i18n.locale);
    this.child_id = this.childData.id;
    let shop = storage.get(UNIFORM_SHOPPING + "_" + this.childData.family_id) || { shopping: {}, order: [] };
    this.infoList = shop.shopping;
    this.getShopNum();
  },
  methods: {
    getShopNum() {
      var result = [];
      for (let item in this.infoList) {
        for (let list in this.infoList[item]) {
          result.push(this.infoList[item][list]);
        }
      }
      this.shopNum=0
      result.forEach((item) => {
        if (typeof item === 'object' && item !== null && item.num) {
          // 套装商品：取 num 值
          this.shopNum += item.num;
        } else if (typeof item === 'number') {
          // 普通商品：直接取数值
          this.shopNum += item;
        }
      })
    },
    initAction() {
      this.colorNum = "";
      this.currentStock = null;
      this.sizeNum = "";
      if (this.shoppingData.attr) {
        this.itemList = this.shoppingData;
        this.currentPrice = this.shoppingData.unit_price;
        this.scribing_price = this.shoppingData.scribing_price;
        this.colorItem = {};
        for (let key in this.itemList.attr.color.item) {
          this.colorItem[key] = {
            disabled: false,
            title: this.itemList.attr.color.item[key],
          };
        }
        this.sizeItem = {};
        for (let key in this.itemList.attr.size.item) {
          this.sizeItem[key] = {
            disabled: false,
            title: this.itemList.attr.size.item[key],
          };
        }
      }
      if (this.itemList.is_bundles) {
        for (let i = 0; i < this.itemList.bundle_items.length; i++) {
          Vue.set(this.itemList.bundle_items[i], "sizeNum", "");
          Vue.set(this.itemList.bundle_items[i], "showSize", false);
        }
        this.colorNum = 6;
      }
      this.imgUrl = this.itemList.img.all ? this.itemList.img.all[0] : DEFAULT_IMG_URL;
      this.quantityNum = 1;
      this.show = this.actionShow;
      let shop = storage.get(UNIFORM_SHOPPING + "_" + this.childData.family_id) || { shopping: {}, order: [] };
      this.infoList = shop.shopping;
    },
    suitSizeClick(lists, key) {
      lists.sizeNum = key;
    },
    getBundleNum(bundle_items) {
      let num = 0;
      bundle_items.forEach((item) => {
        num += item.num;
      });
      return num;
    },
    colorClick(item) {
      if (item == this.colorNum) {
        this.colorNum = "";
        this.quantityNum = 1;
        this.currentPrice = this.shoppingData.unit_price;
        this.scribing_price = this.shoppingData.scribing_price;
        this.currentStock = null;
        this.imgUrl = this.itemList.img.all ? this.itemList.img.all[0] : DEFAULT_IMG_URL;
        for (let key in this.itemList.attr.size.item) {
          this.sizeItem[key].disabled = false;
        }
        return;
      }
      this.colorNum = item;
      for (let key in this.itemList.attr.size.item) {
        if (this.itemList.sku[item][key]) {
          this.sizeItem[key].disabled = false;
        } else {
          this.sizeItem[key].disabled = true;
        }
      }
      let colorImgs = this.itemList.img[this.itemList.attr.color.item_cn[this.colorNum]];
      this.imgUrl = (colorImgs && colorImgs[0]) || (this.itemList.img.all && this.itemList.img.all[0]) || DEFAULT_IMG_URL;
      if (this.sizeNum != "" && this.colorNum != "") {
        this.getStock();
      }
    },
    sizeClick(item) {
      if (item == this.sizeNum) {
        if (this.itemList.is_bundles) {
          for (let i = 0; i < this.itemList.bundle_items.length; i++) {
            this.itemList.bundle_items[i].sizeNum = '';
          }
        }
        this.sizeNum = "";
        this.quantityNum = 1;
        this.currentPrice = this.shoppingData.unit_price;
        this.scribing_price = this.shoppingData.scribing_price;
        this.currentStock = null;
        for (let key in this.itemList.sku) {
          this.colorItem[key].disabled = false;
        }
        return;
      }
      this.sizeNum = item;
      if (this.itemList.is_bundles) {
        for (let i = 0; i < this.itemList.bundle_items.length; i++) {
          this.itemList.bundle_items[i].sizeNum = item;
        }
      }
      for (let key in this.itemList.sku) {
        if (this.itemList.sku[key][item]) {
          this.colorItem[key].disabled = false;
        } else {
          this.colorItem[key].disabled = true;
        }
      }
      if (this.sizeNum != "" && this.colorNum != "") {
        this.getStock();
      }
    },
    getStock() {
      this.quantityNum = 1;
      this.currentPrice = this.itemList.sku[this.colorNum][this.sizeNum].price;
      this.scribing_price = this.itemList.sku[this.colorNum][this.sizeNum].scribing_price;
      this.currentStock = this.itemList.sku[this.colorNum][this.sizeNum].stock;
    },
    reduceNum() {
      if (this.quantityNum <= 1) {
        // Toast(this.$t("最少购买一件"));
        return;
      } 
      this.quantityNum = this.quantityNum - 1;
      
    },
    addNum() {
      if (this.itemList.unlimited == 1) {
        this.quantityNum = this.quantityNum + 1;
        return;
      }
      if (this.currentStock != 0 && this.quantityNum >= this.currentStock) {
        return;
      }
      this.quantityNum = this.quantityNum + 1;
    },
    addShop() {
      if (this.colorNum == "") {
        Toast(this.$t("uniform.select_specifications"));
        return;
      }
      if (this.sizeNum == "") {
        Toast(this.$t("uniform.select_specifications"));
        return;
      }
      let paid = this.itemList.sku[this.colorNum][this.sizeNum].paid;
      let cid = this.itemList.cid || 0;
      let cartKey = paid + '_' + cid;  // 组合键：区分同一商品在不同分类下
      if (this.itemList.is_bundles) {
        if (!this.infoList[this.child_id]) {
          this.infoList[this.child_id] = {};
        }
        let bundleList = [];
        for (let i = 0; i < this.itemList.bundle_items.length; i++) {
          let items = this.itemList.bundle_items[i];
          let bundlePaid = '';
          let bundle = this.itemList.bundleInfo[items.pid];
          if (bundle.attr_special.length == 0) {
            bundlePaid = bundle.sku[items.attr1][items.sizeNum].paid;
          } else if (bundle.attr_special.list) {
            bundlePaid = bundle.sku[items.attr1][bundle.attr_special.list[items.sizeNum]].paid;
          } else if (bundle.attr_special.only) {
            bundlePaid = bundle.sku[items.attr1][bundle.attr_special.only].paid;
          }
          bundleList.push({ id: items.id, paid: bundlePaid });
        }
        if (this.infoList[this.child_id][cartKey]) {
          let existingData = this.infoList[this.child_id][cartKey];
          let isSame = true;
          if (existingData.list && existingData.list.length === bundleList.length) {
            for (let i = 0; i < bundleList.length; i++) {
              if (existingData.list[i].id !== bundleList[i].id ||
                  existingData.list[i].paid !== bundleList[i].paid) {
                isSame = false;
                break;
              }
            }
          } else {
            isSame = false;
          }
          if (!isSame) {
            this.infoList[this.child_id][cartKey] = { cid: cid, list: bundleList, num: this.quantityNum };
          } else {
            this.infoList[this.child_id][cartKey].num += this.quantityNum;
          }
        } else {
          this.infoList[this.child_id][cartKey] = { cid: cid, list: bundleList, num: this.quantityNum };
        }
      } else {
        // 非套装：组合键 {paid}_{cid}，兼容旧格式
        if (!this.infoList[this.child_id]) {
          this.infoList[this.child_id] = {};
        }
        let prevNum = 0;
        let existing = this.infoList[this.child_id][cartKey];
        if (typeof existing === 'object' && existing !== null && typeof existing.num === 'number') {
          prevNum = existing.num;
        } else if (typeof existing === 'number') {
          prevNum = existing;
        }
        this.infoList[this.child_id][cartKey] = { cid: cid, num: prevNum + this.quantityNum };
      }
      // return;
      let shop = {
        shopping: this.infoList,
        order: {},
      };
      storage.set(UNIFORM_SHOPPING + "_" + this.childData.family_id, shop);
      this.quantityNum = 1;
      this.getShopNum();
      Toast.success(this.$t("uniform.added_Cart"));
      this.show = false;
    },
    showAction() {
      this.show = false;
      this.$emit("click", false);
    },
    register() {
      if (this.colorNum == "") {
        Toast(this.$t("uniform.select_specifications"));
        return;
      }
      if (this.sizeNum == "") {
        Toast(this.$t("uniform.select_specifications"));
        return;
      }
      this.registerLoading = true;
      recordWant({ aid: this.itemList.sku[this.colorNum][this.sizeNum].paid, child_id: this.child_id, num: this.quantityNum })
        .then((res) => {
          if (res.code == 0) {
            Toast.success(res.msg);
          }
          this.registerLoading = false;
        })
        .catch(() => {
          this.registerLoading = false;
        });
    },
    buyNow() {
      if (this.colorNum == "") {
        Toast(this.$t("uniform.select_specifications"));
        return;
      }
      if (this.sizeNum == "") {
        Toast(this.$t("uniform.select_specifications"));
        return;
      }
      let shop = storage.get(UNIFORM_SHOPPING + "_" + this.childData.family_id) || { shopping: {}, order: [] };
      // 构建要保存的订单项
      let orderItem = {
        cid: this.itemList.cid,
        pid: this.itemList.pid,
        is_bundles: this.itemList.is_bundles || false,
        paid: this.itemList.sku[this.colorNum][this.sizeNum].paid,
        title: this.itemList.title,
        num: this.itemList.num,
        unit_price:  this.itemList.sku[this.colorNum][this.sizeNum].price,
        scribing_price: this.itemList.scribing_price,
        status: 1,
        attr1: this.itemList.attr.color.item[this.colorNum],
        attr2: this.itemList.attr2 || this.sizeItem[this.sizeNum].title,
        img: this.itemList.img.all[0],
        child_id: this.child_id,
        quantity: this.quantityNum,
        stock: this.quantityNum,
        check: true,
      };
      // 如果是套装商品，添加套装信息
      if (this.itemList.is_bundles) {
        orderItem.is_bundle_main = true;
        let pidStr = this.itemList.paid;
        orderItem.bundle_items = [];
        for (let i = 0; i < this.itemList.bundle_items.length; i++) {
          let items = this.itemList.bundle_items[i];
          let bundlePaid=''
          let bundle =this.itemList.bundleInfo[items.pid]
           if(bundle.attr_special.length==0){
             bundlePaid = bundle.sku[items.attr1][items.sizeNum].paid;
          }else if(bundle.attr_special.list){
             bundlePaid = bundle.sku[items.attr1][bundle.attr_special.list[items.sizeNum]].paid;
          }else if(bundle.attr_special.only){
             bundlePaid = bundle.sku[items.attr1][bundle.attr_special.only].paid;
          }
          pidStr += "_" + bundlePaid;
          orderItem.bundle_items.push({
            cid: items.cid,
            pid: items.pid,
            id: items.id,
            is_bundles: false,
            paid: bundlePaid,
            title: items.abb_title,
            num: items.num,
            unit_price: items.unit_price,
            scribing_price: items.scribing_price,
            status: 1,
            attr1: bundle.attr.color.item[items.attr1],
            attr2: bundle.attr_special.length==0?this.sizeItem[items.sizeNum].title:bundle.attr_special.list? bundle.attr.size.item[bundle.attr_special.list[items.sizeNum]]:bundle.attr_special.only? bundle.attr.size.item[bundle.attr_special.only]:'',
            img: bundle.img.all[0],
            child_id: this.child_id,
            abb_title: items.abb_title,
            quantity: items.num,
            is_bundle_item: true,
            original_key: pidStr,
          });
        }
        orderItem.original_key = pidStr;
      }
      shop.order = [];
      shop.order.push(orderItem);
      storage.set(UNIFORM_SHOPPING + "_" + this.childData.family_id, shop);
      this.$router.push({
        name: "UniformConfirm",
      });
      // creatOrder({ product })
      //   .then((order) => {
      //     if (order.code == 0) {
      //       JSAPIPa({ order_id: order.data.order_id, invoice_id: order.data.invoice_id, child_id: this.child_id })
      //         .then((res) => {
      //           let that = this;
      //           wx.config({
      //             // debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      //             appId: res.data.jsapiParams.appId,
      //             jsApiList: ["chooseWXPay"], // 必填，需要使用的JS接口列表
      //           });
      //           wx.ready(function () {
      //             wx.chooseWXPay({
      //               appId: res.data.jsapiParams.appId, //公众号ID，由商户传入
      //               timestamp: res.data.jsapiParams.timeStamp, //时间戳，自1970年以来的秒数
      //               nonceStr: res.data.jsapiParams.nonceStr, //随机串
      //               package: res.data.jsapiParams.package,
      //               signType: res.data.jsapiParams.signType, //微信签名方式：
      //               paySign: res.data.jsapiParams.paySign, //微信签名
      //               success() {
      //                 that.showLoading = false;
      //                 Toast.success(that.$t("uniform.Payment_successful"));
      //                 that.$router.push({
      //                   name: "UnifromOrder",
      //                 });
      //                 // 支付成功回调
      //               },
      //               cancel() {
      //                 Toast.fail(that.$t("uniform.Cancel_Payment"));
      //                 that.showLoading = false;
      //                 that.getCancelPay(order.data.invoice_id);
      //               },
      //               fail() {
      //                 that.showLoading = false;
      //                 Toast.fail(that.$t("uniform.Payment_Failed"));
      //                 that.getCancelPay(order.data.invoice_id);
      //                 // 支付失败回调
      //               },
      //             });
      //           });
      //         })
      //         .catch(() => {
      //           this.showLoading = false;
      //         });
      //     } else {
      //       this.showLoading = false;
      //       this.currentStock = order.data[0].num;
      //     }
      //   })
      //   .catch(() => {
      //     this.showLoading = false;
      //   });
    },
    getCancelPay(invoice_id) {
      cancelPay({ invoice_ids: invoice_id }).then((invoice) => {
        console.log(invoice);
      });
    },
    router() {
      this.$router.push({
        name: "UniformShop",
      });
    },
    touchstartHandle(refName, e) {
      // 触摸开始
      let touchTarget = e.targetTouches[0];
      // 记录触摸点的坐标（初始位置）
      this.touch.initialPosition = {
        x: touchTarget.clientX,
        y: touchTarget.clientY,
      };
      // 记录需要移动的元素坐标（初始位置）
      this.element.initialPosition = {
        x: this.$refs[refName].offsetLeft,
        y: this.$refs[refName].offsetTop,
      };
    },
    touchmoveHandle(refName, e) {
      e.preventDefault();
      let touchTarget = e.targetTouches[0];
      let X = this.element.initialPosition.x + (touchTarget.clientX - this.touch.initialPosition.x);
      let Y = this.element.initialPosition.y + (touchTarget.clientY - this.touch.initialPosition.y);
      let maxWidth = innerWidth - this.$refs[refName].offsetWidth;
      let maxHeight = innerHeight - this.$refs[refName].offsetHeight;
      X = X <= 0 ? 0 : X >= maxWidth ? maxWidth : X;
      Y = Y <= 0 ? 0 : Y >= maxHeight ? maxHeight : Y;
      this.nowLeft = X;
      this.classFlag = Y < 300;
      // 移动元素
      this.$refs[refName].style.left = X + "px";
      this.$refs[refName].style.top = Y + "px";
    },
    end(refName) {
      if (this.nowLeft < 0) {
        return;
      }
      // 吸边处理
      let halfMaxWidth = (innerWidth - this.$refs[refName].offsetWidth) / 2;
      const dragDiv = this.$refs[refName];
      if (this.nowLeft > halfMaxWidth) {
        // 右吸边
        dragDiv.style.left = document.documentElement.clientWidth - parseInt(dragDiv.clientWidth) - 16 + "px";
      } else {
        // 左吸边
        dragDiv.style.left = "16px";
      }
      dragDiv.style.top = dragDiv.offsetTop + "px";
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.fontWeight {
  font-weight: 500;
}
.suitLabel {
  padding: 6px 8px;
  background: #f7f8fa;
  border-radius: 4px;
}
.colorWarning {
  color: #ed6a0c;
}
.mt-4 {
  margin-top: 4px;
}
.content {
  padding: 16px;
  margin-bottom: 50px;

  .img72 {
    width: 72px;
    height: 72px;
    border-radius: 8px;
    object-fit: contain;
  }

  .categoryTitle {
    color: #323233;
    font-size: 14px;
    font-weight: 500;
    margin: 20px 0 12px 0;
  }

  .tagList {
    color: #323233;
    font-size: 13px;
    padding: 7px 16px;
    background: #f7f8fa;
    border-radius: 4px;
    margin-bottom: 8px;
    margin-right: 12px;
    display: inline-block;
    position: relative;
    border: 1px solid transparent;

    .NoStock {
      right: -10px;
      bottom: 25px;
      background: #ee0a24;
      display: inline-block;
      line-height: 4vw;
      position: absolute;
      border-radius: 50px;
      color: #fff;
      font-size: 3.2vw;
      display: inline-block;
      padding: 2px 4px;
      z-index: 99;
    }
    .presale {
      right: -10px;
      bottom: 25px;
      background: #5cb85c;
      display: inline-block;
      line-height: 4vw;
      position: absolute;
      border-radius: 50px;
      color: #fff;
      font-size: 3.2vw;
      display: inline-block;
      padding: 2px 4px;
      z-index: 99;
    }
  }
}

.van-sku-stepper-stock {
  padding: 0;
  margin-bottom: 50px !important;
}

.currentTag {
  background: rgba(77, 136, 210, 0.1) !important;
  color: #4d88d2 !important;
  font-weight: 500;
  border: 1px solid #4d88d2 !important;
}

.disabledTag {
  // background:#f2f3f5 !important;
  color: #999 !important;
}

.shopping {
  width: 50px;
  height: 50px;
  // background: #4d88d2;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 50%;
  position: fixed;
  right: 16px;
  bottom: 110px;
  line-height: 55px;
  text-align: center;
  z-index: 99;

  .num {
    width: 16px;
    height: 16px;
    background: #ee0a24;
    display: inline-block;
    line-height: 16px;
    position: absolute;
    border-radius: 50%;
    color: #fff;
    font-size: 12px;
    top: 0px;
    right: 0px;
    border: 0.8px solid #fff;
  }
}

.colorRed {
  color: #ee0a24;
}

.p10 {
  padding: 10px;
}

.van-stepper__input {
  pointer-events: none;
}
.noticeBto {
  color: rgb(102, 102, 102);
  background: rgb(242, 243, 245);
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 70px;
}
</style>
